import PostBlog from '@/components/posts/PostContentType01';
import PostList from '@/components/posts/PostContentType02';
//import PostGallery from '@/components/posts/PostContentType03';
import PostImage from '@/components/posts/PostContentType05';
import PostContent from '@/components/posts/PostContent';
import { updateMenu, morelink } from '@/utils/menu.js';
export const postRecent ={
    data(){
        return {            
            slideLists:'',

            gamegradeLists:'',
            mentoryLists:'',
            newsLists:'',

            freeLists:'',
            humorLists:'',
            photoLists:'',
            marketplaceLists:'',
            steamweakyLists:'',

            isLoading:false,
            
            isLoading_gamegrade:false,
            isLoading_mentory:false,
            isLoading_news:false,

            isLoading_free:false,            
            isLoading_humor:false,
            isLoading_photo:false,

            isLoading_marketplace:false,

            isLoading_steamweaky:false,
        }
    },
    components:{
        PostBlog,
        PostList,
        //PostGallery,
        PostImage,
        PostContent
    },
    created(){
        this.recentPost('slide',20);   

       
    },
    computed:{  
        fetchslideLists(){
            return this.slideLists;
        },

        fetchGamegradeLists(){
            return this.gamegradeLists;
        },
        fetchMentoryLists(){
            return this.mentoryLists;
        },
        fetchNewsLists(){
            return this.newsLists;
        },

        fetchFreeLists(){
            return this.freeLists;
        },
        fetchHumorLists(){
            return this.humorLists;
        },
        fetchPhotoLists(){
            return this.photoLists;
        },
        fetchMarketPlaceLists(){
            return this.marketplaceLists;
        },
        fetchSteamWeakyLists(){
            return this.steamweakyLists;
        },
        

    },
    methods:{
        moreview(menu,post,ismobile){
            updateMenu(menu,'all', this.$store); 
            morelink(menu,post,ismobile, this.$router)   
        },
        async recentPost(get,limit){
            //최신글 가져오기
            if(get ==="slide")   this.isLoading = true;

            if(get ==="gamegrade")   this.isLoading_gamegrade = true;
            if(get ==="mentory")   this.isLoading_mentory = true;
            if(get ==="news")   this.isLoading_news = true;

            if(get ==="free")   this.isLoading_free = true;            
            if(get ==="humor")  this.isLoading_humor = true;
            if(get ==="photo") this.isLoading_photo = true;

            if(get ==="marketplace") this.isLoading_marketplace = true;

            if(get ==="steamweaky") this.isLoading_steamweaky = true;

            const data={sort:get,user_id:this.$store.getters.currentUser.id, limit:limit};
            try {
                const response = await this.$store.dispatch("posts/getRecent",data)
                //console.log('최신글',response);  

                if(get ==="slide") 
                {
                    this.slideLists = response;  
                    this.recentPost('gamegrade');        
                } 

                if(get ==="gamegrade"){
                    this.gamegradeLists = response;
                    this.recentPost('mentory');
                } 
                if(get ==="mentory"){
                    this.mentoryLists = response;
                     this.recentPost('news');
                } 
                if(get ==="news"){
                    this.newsLists = response;
                     this.recentPost('free');
      
                } 

                if(get ==="free"){
                    this.freeLists = response;
                      this.recentPost('humor');
        
                } 
                if(get ==="humor"){
                    this.humorLists = response;
                    this.recentPost('photo');   
                    this.recentPost('marketplace',6);   
                } 
                // if(get ==="photo"){
                //     this.photoLists = response;
                //     this.recentPost('marketplace',8);
                // } 

                if(get ==="marketplace"){
                    this.marketplaceLists = response;
                    this.recentPost('steamweaky',6);   
                } 

                if(get ==="steamweaky"){
                    this.steamweakyLists = response;
                } 
                
            }catch(error){
                console.log(error.response);
            }            
           
            if(get ==="slide")   this.isLoading = false;
            if(get ==="gamegrade")   this.isLoading_gamegrade = false;
            if(get ==="mentory")   this.isLoading_mentory = false;
            if(get ==="news")   this.isLoading_news = false;

            if(get ==="free")   this.isLoading_free = false;
            if(get ==="humor")  this.isLoading_humor = false;
            if(get ==="photo") this.isLoading_photo = false;

            if(get ==="marketplace") this.isLoading_marketplace = false;
           
            if(get ==="steamweaky") this.isLoading_steamweaky = false;
        }
    }
}